import styled, { css } from 'styled-components'

import e2eClasses from 'helpers/automation'

export const Container = styled.div.attrs(props => ({
  className: props.e2eClass && `${e2eClasses('common.input')}${props.e2eClass}`
}))`
  --bounce-animation: cubic-bezier(0.61, 1.01, 0.51, 1.84);
  flex: 1;

  .react-select__value-container--has-value {
    overflow: hidden;
  }

  ${({ showBoxShadow }) =>
    showBoxShadow &&
    `
    border-radius: 3px;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 26%), 0 2px 5px 0 rgb(0 0 0 / 6%);
  `}

  .react-select__control {
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 3px;
    border: solid 1px ${({ theme }) => theme.colors.grayLight};
    font-family: ${({ theme }) => theme.fonts.regular};
    font-size: ${({ fontSize }) => fontSize || '14px'};
    cursor: pointer;
    padding: ${({ small, light }) => (small ? '0' : light ? '5px' : '6px')};
    &:active {
      border: none;
      border: solid 1px ${({ theme }) => theme.colors.blue};
      box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.26), 0 2px 5px 0 rgba(0, 0, 0, 0.06);
    }

    ${({ error }) =>
      error &&
      css`
        border: solid 1px ${({ theme }) => theme.colors.red};
      `};
  }

  .react-select__placeholder {
    color: ${({ theme }) => theme.colors.doveGray};
  }

  .react-select__value-container {
    width: 100%;
    .react-select__single-value {
      color: ${({ small, theme }) => (small ? theme.colors.blueDark : theme.colors.blue)};
      font-family: ${({ small, theme }) => (small ? theme.fonts.regular : theme.fonts.semiBold)};
    }
  }
  .react-select__indicators {
    .react-select__dropdown-indicator {
      transition: transform 0.4s var(--bounce-animation);
    }
  }

  .react-select__control--is-focused {
    border: solid 1px ${({ theme }) => theme.colors.blue};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.black};
    input:focus {
      box-shadow: none;
    }
    .react-select__indicators .react-select__dropdown-indicator {
      transform: rotate(180deg);
    }
  }
  .react-select__menu {
    margin-top: 1px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    font-size: ${({ fontSize }) => fontSize || 'inherit'};
    .react-select__menu-list {
      max-height: 250px;
      padding: 0;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border: solid 1px ${({ theme }) => theme.colors.blue};
      border-top: 1px solid transparent;
      color: ${({ theme }) => theme.colors.dustyGray};
      font-family: ${({ theme }) => theme.fonts.regular};
      .react-select__option--is-selected {
        background-color: ${({ theme }) => theme.colors.transparent};
        font-family: ${({ theme }) => theme.fonts.semiBold};
        color: ${({ theme }) => theme.colors.blue};
      }
      .react-select__option--is-focused {
        cursor: pointer;
        font-family: ${({ theme }) => theme.fonts.semiBold};
        background-color: ${({ theme }) => theme.colors.blueLighter};
        color: ${({ theme }) => theme.colors.blueDark};
        font-family: ${({ theme }) => theme.fonts.semiBold};
      }
    }
  }
  .react-select__control--is-disabled {
    background-color: ${({ theme }) => theme.colors.grayLighter};
  }
`

export const InputLabel = styled.label`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

export const StyledOption = styled.div`
  padding: 8px 12px;
  cursor: ${({ isOptionDisabled }) => (isOptionDisabled ? 'not-allowed' : 'pointer')};
  color: ${({ isSelected, theme }) => (isSelected ? theme.colors.blue : theme.colors.doveGray)};
  font-family: ${({ isSelected, theme }) => isSelected && theme.fonts.semiBold};

  :hover {
    background-color: ${({ theme }) => theme.colors.blueLighter};
    color: ${({ theme }) => theme.colors.blueDark};
  }
`
